import { render, staticRenderFns } from "./SpecialistLicensesAndDisciplines.vue?vue&type=template&id=faab97b0&"
import script from "./SpecialistLicensesAndDisciplines.vue?vue&type=script&lang=js&"
export * from "./SpecialistLicensesAndDisciplines.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports